import {Injectable} from "@angular/core";
import {FormField} from "../../../../../../../sellions_forms/projects/forms/src/lib/interfaces/form-field.interface";
import {ProcessFormMappingConfig} from "../../interfaces/process-form-mapping-config.interface";

@Injectable()
export class ProcessFormService {

  public mapFormData(config: ProcessFormMappingConfig, fields: FormField[], data: any): FormField[] {
    const mapping = config.formMapping;

    fields.forEach((field: FormField) => {
      this.setPredefinedValue(config, field, data, mapping[field.id]);
    });
    return fields;
  }

  private setPredefinedValue(config: ProcessFormMappingConfig, field: FormField, data: any, fieldMapping: any) {
    if(!data)
      return;
    if (field.type === 'list') this.setPredefinedList(config, field, data, fieldMapping);
    else field.predefinedValue = this.getValue(config, data[fieldMapping], field);
  }

  private setPredefinedList(config: ProcessFormMappingConfig, field: FormField, data: any, fieldMapping: any) {
    if (Array.isArray(data[fieldMapping])) this.setPredefinedObjectArray(config, field, data[fieldMapping]);
    else if (field.subForm.definition.length == 1) {
      field.subForm.definition[0].predefinedValue = data[fieldMapping];
    } else {
      // flatten data_view [path] data -> subform
      this.setSubFormFields(fieldMapping, field, data);
    }
  }

  private setSubFormFields(fieldMapping: any, field: FormField, data: any) {
    const subFormMapping = Object.keys(fieldMapping).map(key => [key, fieldMapping[key]]);
    for (let [subFormFieldName, flatDataPathFieldName] of subFormMapping) {
      this.setSubFormFieldsFromFlattenDataFields(field, subFormFieldName, data, flatDataPathFieldName);
    }
  }

  private setSubFormFieldsFromFlattenDataFields(formField: FormField, subFormFieldName, data: any, flatDataPathFieldName) {
    formField.subForm.definition.forEach((subFormField: FormField) => {
      if (subFormField.id === subFormFieldName) {
        subFormField.predefinedValue = data[flatDataPathFieldName];
      }
    });
  }

  private setPredefinedReferencesFromArrayValue(config: ProcessFormMappingConfig, value: any, field: FormField): string[] {
    let referenceFields: string[] = [];
    value.forEach((predefinedReference) => {
      const referenceField = this.setPredefinedReference(config, predefinedReference, field);
      referenceFields.push(referenceField);
    });

    return referenceFields;
  }

  private setPredefinedReference(config: ProcessFormMappingConfig, value: any, field: FormField): string {
    return value[config.referenceMapping[field.id]];
  }

  private setPredefinedObjectArray(config: ProcessFormMappingConfig, field: FormField, value: any[]) {
    field.predefinedValue = this.getObjectValues(config, value, field.subForm.definition);
  }

  private getObjectValues(config: ProcessFormMappingConfig, values: any, definition: FormField[]) {
    values.forEach((value: any) => {
      definition.forEach((field) => this.getValue(config, value, field));
      return value;
    });
    return values;
  }

  private getValue(config: ProcessFormMappingConfig, value: any, field: FormField): any {
    if (field.dataSource === 'dataView') {
      const predefinedReferencesInArray = Array.isArray(value);

      if (predefinedReferencesInArray) {
        return this.setPredefinedReferencesFromArrayValue(config, value, field);
      } else {
        return value;
      }
    }

    return value;
  }

}



// WEBPACK FOOTER //
// ./src/submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/services/process/process-form.service.ts